import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-placeholder-row-edit',
  templateUrl: './placeholder-row-edit.component.html',
  styleUrls: ['./placeholder-row-edit.component.css'],
  imports: [MatIconModule, CommonModule]
})
export class PlaceholderRowEditComponent {

}
